import React from "react";
import { BsNutFill } from "react-icons/bs";

const TextInputFloat = ({
  id,
  type = "text",
  label,
  placeholder,
  value,
  setValue,
  error = null,
  Icon = null,
  required=true
}) => {
  return (
    <div className="w-full">
      <div className="relative w-full">
        <input
          type={type}
          required={required}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          id={`floating_outlined${id}`}
          className={`block py-4 ${Icon ? "pl-12" : "pl-4"
            } pr-4 w-full text-sm text-ep_White dark:text-white bg-white/20 dark:bg-gray-800/95
                 rounded-xl border-2 border-crimson/20 dark:border-crimson/40 appearance-none
                 hover:border-crimson/40 dark:hover:border-crimson/60 focus:border-crimson dark:focus:border-crimson focus:outline-none
                 focus:ring-4 focus:ring-crimson/10 dark:focus:ring-crimson/20 transition-all duration-400 peer backdrop-blur-xl
                 hover:shadow-lg focus:shadow-lg`}
          placeholder={placeholder}
        />
        <label
          htmlFor={`floating_outlined${id}`}
          className={`absolute ${Icon ? "pl-10" : "pl-4"
            } text-sm text-charcoal dark:text-white/70 duration-400 font-bold
                transform -translate-y-4 scale-75 top-2 z-10 origin-[0] peer-focus:bg-white dark:peer-focus:bg-gray-800
                bg-white dark:bg-gray-800 px-3 peer-focus:px-3 peer-focus:text-crimson dark:peer-focus:text-golden peer-placeholder-shown:scale-100
                peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2
                peer-focus:scale-75 peer-focus:-translate-y-4 left-1 rounded-lg`}
        >
          {label}
        </label>
        <span className="absolute left-4 top-1/2 transform -translate-y-1/2 text-crimson dark:text-golden transition-colors duration-300">
          {Icon}
        </span>
      </div>
      {error && (
        <p
          id="outlined_error_help"
          className="text-xs font-bold text-crimson dark:text-golden mt-2 ml-3 bg-crimson/5 dark:bg-golden/10 px-2 py-1 rounded-lg"
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default TextInputFloat;
